import * as React from "react"
import type { SVGProps } from "react"
const SvgUndo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8 19.14a1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72q0-.42.29-.71a1 1 0 0 1 .71-.29h6.1q1.57 0 2.74-1 1.16-1 1.16-2.5c0-1.5-.39-1.83-1.16-2.5q-1.17-1-2.74-1H7.8l1.9 1.9a1 1 0 0 1 .28.7 1 1 0 0 1-.28.7 1 1 0 0 1-.7.28 1 1 0 0 1-.7-.28l-3.6-3.6a1 1 0 0 1-.21-.32 1 1 0 0 1-.06-.38q0-.2.06-.37a1 1 0 0 1 .21-.33l3.6-3.6a1 1 0 0 1 .7-.27q.42 0 .7.27a1 1 0 0 1 .28.7 1 1 0 0 1-.28.7l-1.9 1.9h6.3q2.43 0 4.16 1.58A5 5 0 0 1 20 13.64q0 2.36-1.74 3.93a6 6 0 0 1-4.16 1.57z" />
  </svg>
)
export default SvgUndo
